import share from "@assets/web-v3-images/btn-share.png";

const ShareIcon = ({ width = 96, height = 96, className }) => (
  <img src={share} alt="" width={width} height={height} className={className} />
);

export default ShareIcon;
